import React from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { hasPermissionsFor } from 'helpers/_helpers';
import styles from './styles';
// import { drawerTypes } from '../helpers/drawerTypes';
import { useNavigate } from '../../../../node_modules/react-router-dom/index';

const EquipmentHeader = ({ classes, openDrawer }) => {
  const navigate = useNavigate();

  const onEquipmentScheduleClick = () => {
    navigate('/equipment')
  }

  return (
    <header className={classes.header}>
      <div className={classes.headerTitle}>
        <Typography variant="h3">Schedule Display Order</Typography>
        <Button
          variant="outlined"
          color="primary"
          className={classes.equipmentScheduleBtn}
          onClick={onEquipmentScheduleClick}
          disableTouchRipple
        >
          Back To Equipment
        </Button>
      </div>
    </header>
  );
};

EquipmentHeader.propTypes = {
  classes: propTypes.object.isRequired,
  openDrawer: propTypes.func.isRequired,
};

export default withStyles(styles)(EquipmentHeader);
